const comments = [
  {
    id: 1,
    name: '电影爱好者小李',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%20with%20warm%20lighting%2C%20friendly%20expression%2C%20casual%20style%2C%20clean%20dark%20background%2C%20professional%20headshot%20quality&width=96&height=96&seq=avatar-01&orientation=squarish',
    time: '2 天前',
    content: '用了天堂影院快一年了，真的良心！画质清晰流畅，最重要的是完全没有广告。以前在其他网站看个电影要关四五次弹窗，现在打开就能看，体验天差地别。片源更新也很快，新上映的大片基本两三天就能看到高清版。',
    likes: 328,
    tag: '忠实用户',
  },
  {
    id: 2,
    name: '追剧达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20portrait%20with%20soft%20warm%20lighting%2C%20friendly%20smile%2C%20modern%20casual%20style%2C%20clean%20dark%20background%2C%20natural%20headshot&width=96&height=96&seq=avatar-02&orientation=squarish',
    time: '5 天前',
    content: '朋友推荐的天堂影院，第一次用就被圈粉了。片库真的超级全，连很多小众的独立电影都能找到。多线路切换功能也很实用，晚上高峰时段也不卡。已经安利给身边所有喜欢看电影的朋友了！',
    likes: 256,
    tag: '新用户',
  },
  {
    id: 3,
    name: '影评人老张',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20man%20portrait%20with%20warm%20dramatic%20lighting%2C%20thoughtful%20expression%2C%20professional%20style%2C%20clean%20dark%20background%2C%20cinematic%20headshot%20quality&width=96&height=96&seq=avatar-03&orientation=squarish',
    time: '1 周前',
    content: '作为一名写了十年影评的人，我对观影平台的画质和片源质量要求很高。天堂影院的 4K 片源确实达到了收藏级别，色彩还原和暗部细节表现都很出色。更难得的是操作简单，页面干净，适合各个年龄段的用户。',
    likes: 512,
    tag: '资深影迷',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
            观众热评
          </h2>
          <p className="text-sm text-foreground-400 max-w-[500px] mx-auto">
            来自天堂影院用户的真实评价与观影分享
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-[1100px] mx-auto">
          {comments.map((comment) => (
            <article
              key={comment.id}
              className="flex flex-col rounded-lg bg-background-100 border border-background-200/50 p-5 md:p-6 hover:border-primary-500/20 transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden bg-background-300 shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-800 truncate">
                    {comment.name}
                  </h3>
                  <div className="flex items-center gap-2 mt-0.5">
                    <span className="text-xs text-foreground-300">{comment.time}</span>
                    <span className="px-1.5 py-0.5 rounded-md bg-primary-100/60 text-primary-600 text-[10px] font-medium">
                      {comment.tag}
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex gap-0.5 mb-3">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-primary-500 text-xs"></i>
                ))}
              </div>

              <p className="text-sm text-foreground-500 leading-relaxed flex-1">
                {comment.content}
              </p>

              <div className="mt-4 pt-3 border-t border-background-200/30 flex items-center gap-3">
                <span className="flex items-center gap-1 text-xs text-foreground-300 cursor-pointer hover:text-accent-500 transition-colors">
                  <i className="ri-thumb-up-line text-sm"></i>
                  {comment.likes}
                </span>
                <span className="text-xs text-foreground-300 cursor-pointer hover:text-primary-500 transition-colors">
                  回复
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}